import React from "react";
import Registers from "../views/pages/registers/Registers";
import RegistersLayout from "../views/layouts/RegistersLayout";
import { Page404 } from "@duosoftbg/nacid-components";
import AcademicRecognitionsRegister from "../views/pages/registers/search/AcademicRecognitionsRegister";
import ViewObjectLayout from "../views/layouts/ViewObjectLayout";
import AcademicRecognitionView from "../views/pages/registers/view/recognition/AcademicRecognitionView";
import ProfessionalQualificationView from "../views/pages/registers/view/qualification/ProfessionalQualificationView";
import ProfessionalQualificationRegister from "../views/pages/registers/search/ProfessionalQualificationRegister";
import { requestRoutes } from "./requestRoutes";
import { requestAdminRoutes } from "./requestAdminRoutes";
import CertificateView from "../views/pages/registers/view/certificate/CertificateView";
import SeRecognitionCheckup from "../views/pages/registers/view/secondaryRecognition/SeRecognitionCheckup";
import SeRecognitionQrView from "../views/pages/registers/view/secondaryRecognition/SeRecognitionQrView";

const routes = [
  {
    path: "/",
    element: <RegistersLayout />,
    children: [
      { index: true, element: <Registers /> },
      {
        path: "/academic-recognitions",
        element: <AcademicRecognitionsRegister />,
      },
      {
        path: "/professional-qualifications",
        element: <ProfessionalQualificationRegister />,
      },
      ...requestRoutes,
      ...requestAdminRoutes,
    ],
  },
  {
    path: "/academic-recognitions",
    element: <ViewObjectLayout />,
    children: [
      {
        path: "view",
        element: <AcademicRecognitionView />,
      },
    ],
  },
  {
    path: "/secondary-recognition",
    element: <ViewObjectLayout />,
    children: [
      {
        path: "checkup",
        element: <SeRecognitionCheckup />,
      },
    ],
  },
  {
    path: "certificate/secondary-recognition",
    element: <ViewObjectLayout />,
    children: [
      {
        path: "qrcode/view",
        element: <SeRecognitionQrView />,
      },
    ],
  },
  {
    path: "/professional-qualifications",
    element: <ViewObjectLayout />,
    children: [
      {
        path: "view",
        element: <ProfessionalQualificationView />,
      },
    ],
  },
  {
    path: "/certificate",
    element: <ViewObjectLayout />,
    children: [{ index: true, element: <CertificateView /> }],
  },
  {
    path: "*",
    element: <RegistersLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
